import { render, staticRenderFns } from "./DuctPracticalRaw.vue?vue&type=template&id=29a396ea&scoped=true&"
import script from "./DuctPracticalRaw.vue?vue&type=script&lang=js&"
export * from "./DuctPracticalRaw.vue?vue&type=script&lang=js&"
import style0 from "./DuctPracticalRaw.vue?vue&type=style&index=0&id=29a396ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29a396ea",
  null
  
)

export default component.exports